<template>

    <div class="dose-dependent_wrap">
        <DoseDependentContent />
        <DoseDependentCTA />
    </div>
</template>

<script>

import DoseDependentContent from "../components/doseDependent/DoseDependentContent.vue";
import DoseDependentCTA from "../components/doseDependent/DoseDependentCTA.vue";

import headers from "../models/headers";

export default {

    components: {
        DoseDependentContent,
        DoseDependentCTA
    },
    metaInfo: headers.doseDependentPage(),
    data() {
        return {
            videoIsOpen: false
        }
    },
    methods: {
    }

}
</script>
